/* eslint-disable */
import { sendbug } from '../../../app/util/net';

window.__EXCEPTIONTRACE__ = window.__EXCEPTIONTRACE__ ? window.__EXCEPTIONTRACE__ : [];

console.error = function() {
  if (window.__EXCEPTIONTRACE__) {
    window.__EXCEPTIONTRACE__.push(
      {
        message: arguments[0],
        lastStates: '',
      }
    );
  }
  this.apply(console, arguments);
  sendbug();
}.bind(console.error);
